import { render, staticRenderFns } from "./RichContent.vue?vue&type=template&id=0e09b1b3&"
import script from "./RichContent.vue?vue&type=script&lang=js&"
export * from "./RichContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports